// Translation: Interface > Copy button (Ukrainian)
export default Object.freeze({
	idle: '',
	success: ''
})
